module.exports = __webpack_public_path__ + "static/media/icon-new-red.de1d8375.svg";